import React, { useState, useEffect } from "react";
import { Modal } from "react-responsive-modal";
import Scrollbar from "react-scrollbars-custom";
import CommentsList from "./PostFooter/CommentsList";
import PostHeader from "./PostHeader";
import PostContent from "./PostContent";
import PostFooter from "./PostFooter";
import { ReactComponent as CancelIcon } from "assets/img/icons/cancel.svg";
import classNames from "classnames";

function PostModal({ post, open, close, hide }) {
  const color = (post?.data?.color ?? { name: "white" }).name.toLowerCase();
  const color_gradient = post?.data?.color?.color_gradient ?? ["#fff"];
  const textColor = color === "white" ? "#575F6B" : "white";
  const [convertIdToType] = useState({
    1: "Status",
    6: "Slide Show",
    8: "Celebration",
    9: "Bright Idea",
    10: "Topic",
    11: "Team Video",
    20: "Course",
  });
  const [postType, setPostType] = useState(convertIdToType[post?.type_id] ?? 1);
  const [scrollTo, setScrollTo] = useState(0);

  const itemContainerStyles = {
    background:
      post?.type === "welcomemessage"
        ? "linear-gradient(#00A3A3, #8AFFFF)"
        : `linear-gradient(0deg, ${
            color_gradient[1] ?? color_gradient[0]
          } 0%, ${color_gradient[0]} 80%)`,
    color: post?.type === "welcomemessage" ? "white" : textColor,
    fill: textColor,
    borderRadius: "6px",
  };

  useEffect(() => {
    setPostType(convertIdToType[post?.type_id]);
  }, [post, convertIdToType]);

  useEffect(() => {
    setTimeout(() => {
      setScrollTo(476);
    }, 2000);
  }, []);


  return (
    <Modal
      classNames={{
        modalContainer: "modalContainer",
        modal: classNames({
          topicModalContainer: true,
          hideModal: hide ? true : false,
        }),
      }}
      open={open}
      showCloseIcon={false}
      onClose={close}
    >
      <div className="postModalHeader">
        <span className="postType">{postType}</span>
        <span className="closeModal">
          <CancelIcon className="closeIcon" onClick={close} />
        </span>
      </div>
      <div className="singlePostContent" style={itemContainerStyles}>
        <Scrollbar scrollTop={scrollTo}>
          <div className="selectedPostModal">
            <div>
              <PostHeader post={post} color={color} />
              <PostContent post={post} />
              <PostFooter post={post} color={textColor} />
            </div>
            <CommentsList post={post} />
          </div>
        </Scrollbar>
      </div>
    </Modal>
  );
}

export default PostModal;
